import { createSlice } from "@reduxjs/toolkit";

import { networkRequestEntityAdapter } from "./request.adapter";

import type { PayloadAction } from "@reduxjs/toolkit";

const networkRequestsSlice = createSlice({
  name: "networkRequests",
  initialState: networkRequestEntityAdapter.getInitialState(),
  reducers: {
    addOne: networkRequestEntityAdapter.addOne,
    cacheHit: (state, action: PayloadAction<string>) => {
      const requestId = action.payload;
      const request = state.entities[requestId];
      if (!request) {
        return;
      }
      request.cachedResponse = true;
    },
  },
});

export const { actions } = networkRequestsSlice;

export default {
  networkRequests: networkRequestsSlice.reducer,
};
